<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <GridPanel
          :url="'/api/v2/content-layouts/' + $route.params.contentLayoutId + '/content-rows'"
          :portal="portal"
          @create-content-block="$router.push('content-rows/'+$event.id+'/content-blocks/create')"
          @edit-content-block="$router.push('content-rows/'+$event.contentRow.id+'/content-blocks/'+$event.contentBlock.id+'/edit')"
      />

      <FormPanel
          :initial="contentLayout.attributes"
          headline="Edit Layout"
          :errors="errors"
          :layout-categories="layoutCategories"
          :edit="true"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentLayouts/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'
import GridPanel from "../../../../../../../components/Administration/ContentRows/Panels/Grid.vue";

export default {
  components: {GridPanel, LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    },

    blockDrivers:{
      required: true
    },

    layoutCategories:{
      required: true
    }
  },

  data() {
    return {
      contentLayout: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-layouts/' + this.$route.params.contentLayoutId).then(response => {
        this.contentLayout = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-layouts/' + this.$route.params.contentLayoutId, data)
          .then(response => {
            notify.success('The content layout was saved')

            this.contentLayout = response.data.data
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
